<template>
  <v-layout justify-center>
    <v-dialog width="1200px" v-model="dialog" v-closable="{ exclude: [], handler: 'onClickOutside' }" @keydown.esc="$emit('closeDialog')" persistent max-width="800">
      <template v-slot:activator="{ on }" v-if="addBtn">
        <v-btn color="#0e9e98de" dark small absolute top right fab v-on="on">
          <v-icon>add</v-icon>
        </v-btn>
      </template>

      <holidays-form :inDialog="true" :record="record" :errors="errors" @createHoliday="createHoliday" @cancel="onCancel" />
    </v-dialog>
  </v-layout>
</template>

<script>
import HolidaysForm from "./HolidaysForm"

export default {
  name: 'HolidaysDialog',
  components: { 'holidays-form': HolidaysForm },
  props: {
    addBtn: {
      type: Boolean,
      default: true
    },
    record: {
      type: Object
    },
    errors: {
      type: Object
    },
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data(vm) {
    return {
      opening: false
    }
  },
  watch: {
    dialog (val) {
      if (val == false) {
      } else {
        this.opening = true
        setTimeout(function(){
          this.$nextTick(function () {
            this.opening = false
          })
        }.bind(this), 500)
      }
    },
  },
  methods: {
    createHoliday(e) {
      this.$emit('createHoliday')
    },
    onCancel(e) {
      this.$emit('closeDialog')
    },
    onClickOutside() {
      if (!this.isMobile && this.dialog === true && !this.opening) {
        this.$emit('closeDialog')
      }
    }
  },
  computed: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  },
  mounted() {
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
  .align-btn-toogle {
    padding-top: 20px!important;
    width: 100%!important;
    position: absolute!important;
    top: 40px;
    left: 0px;
    box-shadow: none!important;
  }
  .adjust-btn-width {
    width: 50%!important;
  }
  .account-type {
    display: flex;
    align-items: baseline;
    justify-content: left;
    flex-wrap: wrap;
  }
</style>




// WEBPACK FOOTER //
// src/HolidaysDialog.vue